import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { ClientDiagnosticsService } from './client-diagnostics.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(
    private messageService: MessageService,
    private clientDiagnostics: ClientDiagnosticsService,
  ) {}

  handleError(error: HttpErrorResponse, context?: string): Observable<never> {
    // Log error to console or analytics
    console.error('API Error:', error);
    this.clientDiagnostics.track(
      'ui.api_error.handled',
      {
        context,
        status: error.status,
        url: error.url || undefined,
        requestId: error.headers?.get('x-request-id') || undefined,
        message: error.error?.message || error.message,
      },
      error.status >= 500 ? 'error' : 'warn',
    );

    // Handle based on error type
    if (error.status === 500) {
      this.messageService.add({
        severity: 'error',
        summary: `Internal Server Error (${context})`,
        detail: 'An unexpected error occurred. Please try again later or contact support if the issue persists.',
        key: 'error',
        styleClass: 'api-error',
      });
    } else if (error.status === 400) {
      this.messageService.add({
        severity: 'error',
        summary: `Bad Request (${context})`,
        detail: error.error?.message || 'Please verify the order details and try again.',
        key: 'error',
        styleClass: 'api-error',
      });
    } else if (error.status === 409) {
      this.messageService.add({
        severity: 'error',
        summary: `Total Amount Mismatch`,
        detail: error.error?.message || 'Please verify the order details and try again.',
        key: 'error',
        styleClass: 'api-error',
      });
    } else {
      console.log(error);
      this.messageService.add({
        severity: 'error',
        summary: `Error (${context})`,
        detail: error.error?.message || 'An unexpected error occurred.',
        key: 'error',
        styleClass: 'api-error',
      });
    }

    // Re-throw as an observable error
    return throwError(() => error);
  }
}
